/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Checkbox, Tooltip, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import AutoCompleteDropdown from "../../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import Dropdown from "../../../../../components/common/new/Dropdown/Dropdown";
import { FAMILY_FIELDS } from "../../../../../contants/formFields";
import Member from "../../../../../services/api/member";
import { debounce } from "../../../../../utils/helper";
import Styles from "./MemberRow.styles";
import GreenFlag from "../../../../../assets/svg/GreenFlag";
import InputField from "../../../../../components/common/new/InputField/InputField";

const MAX_RESULT = 5;

const OS_OPTIONS = [
  { key: "Yes", value: "yes" },
  { key: "No", value: "no" },
];

const getMemberOptions = (members) =>
  members.length
    ? members.map((member) => ({
        displayName: `${member.fullName} - ${member.addressLine1}`,
        value: member.memberId,
      }))
    : [];

function MemberRow({
  deleteMember,
  member,
  updateMember,
  setFieldValue,
  isEdit,
  index,
  readOnly,
}) {
  const [memberSearchData, setMemberSearchData] = useState([]);
  const [membersData, setMembersData] = useState([]);
  const [loading, setLoading] = useState(false);

  const hasGohonzon =
    member.gohonzon &&
    member.gohonzon.some(
      (membership) => membership?.type === "OKATAKI_GOHONZON"
    );

  console.log("membersData", membersData);

  const getMemberName = (name) => name.split("-")[0].trim();

  const onSearchMember = async (search) => {
    const abortSearch = memberSearchData?.find((m) => m.displayName === search);
    const { isSameOrg } = member;

    if (abortSearch || !search || (!isSameOrg && !Number(search))) return;

    try {
      const formattedQuery = {
        [isSameOrg ? "fullName" : "memberId"]: isSameOrg
          ? search
          : Number(search),
      };
      const params = {
        pageSize: MAX_RESULT,
      };
      setLoading(true);
      const { data } = await Member.search(formattedQuery, params, isSameOrg);
      setMemberSearchData(getMemberOptions(data.content));
      setMembersData(data.content);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Sentry.captureException(error);
    }
  };

  const handleInputChange = useCallback(debounce(onSearchMember), [
    member,
    memberSearchData,
  ]);

  const selectedMember = membersData.find(
    (m) => m.memberId === member.memberId
  );

  const fillAddressDetails = () => {
    if (!member.memberId) return;

    setFieldValue(FAMILY_FIELDS.ADDRESS_LINE_1, selectedMember.addressLine1);
    setFieldValue(FAMILY_FIELDS.STATE, Number(selectedMember.state));
    setFieldValue(FAMILY_FIELDS.CITY, Number(selectedMember.city));
    setFieldValue(FAMILY_FIELDS.PINCODE, Number(selectedMember.pincode));
  };

  useEffect(() => {
    if (isEdit && member.memberId) {
      const { isSameOrg, memberId, name } = member;
      onSearchMember(isSameOrg ? name : memberId);
    }
  }, []);

  return (
    <div style={Styles.formRow}>
      <div style={Styles.mediumItem}>
        <Dropdown
          value={member.isSameOrg ? "yes" : "no"}
          options={OS_OPTIONS}
          label="Same Organisational Structure"
          onChange={(e) =>
            updateMember({ isSameOrg: e.target.value === "yes" }, member.id)
          }
          disabled={readOnly}
        />
      </div>
      <div style={{ ...Styles.longItem }}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.displayName}
          label={member.isSameOrg ? "Search Member Name" : "Search Member ID"}
          name="searchMember"
          options={memberSearchData}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              updateMember({ memberId: "", name: "" }, member.id);
              setMemberSearchData([]);
            } else {
              updateMember(
                {
                  memberId: selectedValue.value,
                  name: getMemberName(selectedValue.displayName),
                },
                member.id
              );
            }
          }}
          onInputChange={handleInputChange}
          value={member.memberId}
          loading={loading}
          filterSelectedOptions={false}
          filterOptions={(x) => x}
          disabled={readOnly}
          style={{ width: "100%" }}
        />
        <Box
          style={{ display: "flex", flexDirection: "row", marginLeft: "12px" }}
        >
          {member.memberId && !readOnly && !isEdit && (
            <InputField
              style={{ width: "55%" }}
              value={selectedMember.divisionName}
              label="Division"
              disabled
            />
          )}
          {isEdit || readOnly ? (
            <InputField
              style={{ width: "55%" }}
              value={member.divisionName}
              label="Division"
              disabled
            />
          ) : null}
        </Box>
      </div>
      <div style={Styles.smallItem}>
        <Typography
          as="span"
          style={
            readOnly
              ? { cursor: "default", ...Styles.defaultAddress }
              : { ...Styles.defaultAddress, cursor: "pointer" }
          }
          onClick={!readOnly ? fillAddressDetails : {}}
        >
          Use as default address
        </Typography>
      </div>

      {isEdit || readOnly ? (
        <>
          <div
            style={
              readOnly
                ? { cursor: "default", ...Styles.item, ...Styles.colName }
                : { ...Styles.item, ...Styles.colName }
            }
          >
            {index === 0 && (
              <Typography
                fontSize="12px"
                style={{ position: "absolute", top: -16 }}
              >
                Gohonzon
              </Typography>
            )}

            {hasGohonzon ? (
              <GreenFlag />
            ) : (
              <HorizontalRuleIcon fontSize="large" style={{ opacity: "0.5" }} />
            )}
          </div>
          <div
            style={
              // readOnly
              // ?
              { cursor: "default", ...Styles.item, ...Styles.colName }
              // : { ...Styles.item, ...Styles.colName }
            }
          >
            {index === 0 && (
              <Typography
                fontSize="12px"
                style={{ position: "absolute", top: -16 }}
              >
                Subscription
              </Typography>
            )}
            {member?.subscription.length > 0 ? (
              <Box style={{ cursor: "default" }}>
                <Checkbox
                  color="success"
                  sx={{
                    cursor: "context-menu",
                  }}
                  disableRipple
                  checked={member?.subscription.length > 0}
                />
              </Box>
            ) : (
              <HorizontalRuleIcon fontSize="large" style={{ opacity: "0.5" }} />
            )}
          </div>
        </>
      ) : null}
      <div
        style={
          readOnly
            ? { cursor: "default", ...Styles.item, ...Styles.colName }
            : { ...Styles.item, ...Styles.colName }
        }
      >
        {index === 0 && (
          <Typography
            fontSize="12px"
            style={{ position: "absolute", top: -16 }}
          >
            Actions
          </Typography>
        )}
        <Tooltip title="Delete">
          <DeleteOutlineIcon
            style={
              readOnly
                ? { cursor: "not-allowed", opacity: "0.5" }
                : { cursor: "pointer" }
            }
            onClick={() => (!readOnly ? deleteMember(member.id) : {})}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default MemberRow;
